import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';

let nextDialogId = 0;
export default function MobileProductDialog({
  title,
  subtitle,
  children,
  footer,
  onClose,
  onSubmit,
  busy = false,
  size = 'wide',
}) {
  const titleId = useRef(null);
  if (!titleId.current) titleId.current = `mobile-product-dialog-${++nextDialogId}`;
  const [height, setHeight] = useState(() => window.visualViewport?.height || window.innerHeight);
  useEffect(() => {
    const viewport = window.visualViewport;
    const resize = () => setHeight(viewport?.height || window.innerHeight);
    viewport?.addEventListener('resize', resize);
    window.addEventListener('resize', resize);
    return () => {
      viewport?.removeEventListener('resize', resize);
      window.removeEventListener('resize', resize);
    };
  }, []);
  const close = () => {
    if (!busy) onClose();
  };
  return (
    <Modal
      show
      animation={false}
      onHide={close}
      keyboard={!busy}
      backdrop={busy ? 'static' : true}
      dialogClassName={`mp-dialog mp-dialog-${size}`}
      style={{ '--mp-viewport-height': `${height}px` }}
      aria-labelledby={titleId.current}
    >
      <form
        className='mp-dialog-form'
        aria-busy={busy}
        onSubmit={event => {
          event.preventDefault();
          if (!busy && onSubmit) onSubmit();
        }}
      >
        <Modal.Header>
          <div className='mp-dialog-title'>
            <Modal.Title as='h2' id={titleId.current}>
              {title}
            </Modal.Title>
            {subtitle && <p>{subtitle}</p>}
          </div>
          <button
            className='mp-icon-button'
            type='button'
            onClick={close}
            disabled={busy}
            aria-label='Закрити'
          >
            ×
          </button>
        </Modal.Header>
        <Modal.Body>{children}</Modal.Body>
        <Modal.Footer>
          {footer || (
            <button type='button' className='btn btn-secondary' disabled={busy} onClick={close}>
              Закрити
            </button>
          )}
        </Modal.Footer>
      </form>
    </Modal>
  );
}
